import {
  handlerGetUrlParams
} from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

export function getFrontSearchResource(data, param) {
  const url = handlerGetUrlParams('/bus/retrieve_resources/home/list', param)
  return request({
    url,
    method: 'POST',
    data
  })
}

export function getSearchResource(data) {
  return request({
    url: '/bus/retrieve_resources/list',
    method: 'POST',
    data
  })
}

export function updateStatus(data) {
  return request({
    url: 'bus/retrieve_resources/batch_update_status',
    method: 'PUT',
    data
  })
}

export function deleteSearchResource(params) {
  return request({
    url: `/bus/retrieve_resources/${params}`,
    method: 'DELETE'
  })
}

export function querySearchResource(id) {
  return request({
    url: `bus/retrieve_resources/info/${id}`,
    method: 'GET'
  })
}

export function addSearchResource(data) {
  return request({
    url: `/bus/retrieve_resources`,
    method: 'POST',
    data
  })
}

export function updateSearchResource(data) {
  return request({
    url: `/bus/retrieve_resources`,
    method: 'PUT',
    data
  })
}
